import { some, get } from "lodash"
import { makeCustomFactorFormatter } from "helpers/formatters/numbers"
import { generateClassificationCompositionQuery } from "helpers/classification"
import { betasSubQuery } from "selectors/missingDataFiles"
import { getOptimizationContentSetsQueryNodes } from "helpers/contentSet"

export const getRuleGroup = (rule) => some([
  rule.contentSetId,
  rule.type === "factor",
]) ? "exposure" : "composition"

export function sameByIdAndType(ruleA, ruleB) {
  const a = `${ruleA.id}${ruleA.type}${ruleA.contentSetId}${ruleA.classificationId}`
  const b = `${ruleB.id}${ruleB.type}${ruleB.contentSetId}${ruleB.classificationId}`
  return a === b
}

export function getRuleType(result) {
  const { type, classificationTier, contentSetId, category } = result
  return classificationTier || contentSetId || category || type
}

export function getResultKey(result) {
  const { type, id, classificationId } = result
  return `${type}-${classificationId || type}-${id}`
}

export function generateSimulationQuery(classifications) {
  return `
    composition(scaleFormat:PERCENT_EQUITY_GMV){
      country:compositionBy(groupBy: COUNTRY){
        id
        economicExposure
      }
      currency:compositionBy(groupBy: CURRENCY){
        id
        economicExposure
      }
      ${generateClassificationCompositionQuery(classifications)}
    }`
}

export function generateExposureQuery(contentSets, missingDataFiles) {
  return `
  exposure{
    factors{
      id
      category
      net
    }
  }
  ${getOptimizationContentSetsQueryNodes(contentSets)}
  ${betasSubQuery(missingDataFiles)}`
}

export const makeRuleValueGetter = ({ id, category, type, contentSetId, classificationId, classificationTier, isCurrency }) => {
  const isBeta = type === "beta"
  const isFactor = type === "factor"
  const isContentSet = !!contentSetId
  const isClassification = !!classificationId

  const formatter = makeCustomFactorFormatter(isCurrency)
  const makeFormattedGet = (path) => (values) => formatter(get(values, path))

  if (isContentSet) {
    return makeFormattedGet(["exposure", contentSetId, id])
  }
  if (isClassification) {
    return makeFormattedGet(["composition", `${classificationId}_${classificationTier}`, id])
  }
  if (isBeta) {
    return makeFormattedGet(["composition", "beta", id])
  }
  if (isFactor) {
    return makeFormattedGet(["exposure", "factors", category, id])
  }

  return makeFormattedGet(["composition", category, id])
}
